module.exports = __webpack_public_path__ + "img/AI (4).0d6a1b86.png";